import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import store from "../../redux/store";
import { Tooltip, Typography, Button, Alert, Collapse, Container, AddIcon, makeStyles, GetAppIcon, DeleteForeverIcon, ButtonGroup, DataGrid, Modal, IconButton, CloseIcon, Grid, Box, LaunchIcon } from "../../components/shared/MaterialUI";
import PaymentService from "../../services/PaymentService";
import { ListStyles } from "../../assets/css/list-style";
import { LoginStyles } from "../../assets/css/login-style";
import { WizardStyles } from '../../assets/css/wizard-style';
import { useUI } from "../../app/context/ui";
import { CSVLink } from "react-csv";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {get as _get} from 'lodash';
const { detect } = require('detect-browser');

const ListPayments = (props) => {

  const history = useHistory();

  const columns = [
    { field: 'name', headerName: 'Filename', flex: 0.4 },
    { field: 'creationDate', headerName: 'Upload date', width: 220 },
    { field: 'user', headerName: 'User', width: 150 },
    { field: 'processingStatus', headerName: 'Status', width: 150,
      renderCell: (params) => (
        (params.row.processingStatus === 1)
          ? <span style={{color:'green'}}>Completed</span>
          : <span style={{ color: 'red' }}>Incompleted</span>
      ),
    },
    { field: 'actionButtons', headerName: 'Actions', flex: 0.3,
      renderCell: (params) => (

        <ButtonGroup variant="contained" color="primary">
          <Tooltip title="Download uploaded file" arrow>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => handleDownloadFile(params.row.route, params.row.nameDownload)}
              startIcon={<GetAppIcon style={{ marginLeft: "9px" }} />}
            >
            </Button>
          </Tooltip>

          <Tooltip title="Download file processed by Paytrace" arrow>
            <Button
              variant="contained"
              style={{ backgroundColor: "rgb(42 140 155)" }}
              size="small"
              onClick={() => handleDownloadFileRecords(params.row.id, params.row.nameDownload)}
              startIcon={<GetAppIcon style={{ marginLeft: "9px" }} />}
            >
            </Button>
          </Tooltip>

          <Tooltip title="View records" arrow>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => { history.push(`/payment-records/${params.row.id}`, { id: params.row.id})}}
              style={{ backgroundColor: "#2f6dba" }}
              startIcon={<LaunchIcon style={{ marginLeft: "9px" }}/>}
            >
            </Button>
          </Tooltip>

          <Tooltip title="Delete file" arrow>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={() => handleOpenModalDelete(params.row.id)}
              style={{ backgroundColor: "#c22020" }}
              startIcon={<DeleteForeverIcon style={{ marginLeft: "9px" }} />}
            >
            </Button>
          </Tooltip>
        </ButtonGroup>
      )
    },
  ];

  const [open, setOpen] = useState(true);
  const [openModalDelete, setopenModalDelete] = useState(false);
  const [paymentDelete, setpaymentDelete] = useState({ idDelete: ''});
  const [, setHasError] = useState({});
  const [, setRequestFailed] = useState(false);
  const [rows, setRows] = useState([]);

  const location = useLocation();
  const classes = useStyles();
  const listStyle = ListStyles();
  const { blockUI } = useUI();
  const wizardStyle = WizardStyles();

  const [modalStyle] = useState(getModalStyle);
  const loginStyles = LoginStyles();

  const state = store.getState();
  const accessToken = state.user.accessToken;

  if (!accessToken) {
    history.push("/login");
  }

  const paymentService = new PaymentService();
  useEffect(() => {
    paymentService.init(accessToken);
  }, [accessToken, rows]);

  useEffect(() => {
    if (!setRequestFailed) {
      setHasError("");
    }
    getListPayment();
  }, [accessToken]);

  const getListPayment = async () => {
    try {
      blockUI.current.open(true);
      setRequestFailed(false);
      const r1 = await paymentService.list();
      setRows(r1.data.data);
      blockUI.current.open(false);
    } catch (e) {
      blockUI.current.open(false);
      setRequestFailed(true);
      const code = _get(e, 'response.status', 0);
      if (code === 401) {
        props.dispatch({ type: 'LOGOUT' });
        history.push('/login');
      }
      setHasError({ message: e.response.data.message });
    }
  };

  const handleDownloadFile = async (route, name) =>{
    try {
      blockUI.current.open(true);
      setRequestFailed(false);
      paymentService.init(accessToken);
      const resp = await paymentService.download(route);
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      const f = getDateWithDetectedBrowser(name);
      let nameDownload = `${f.getFullYear()}:${f.getMonth()}:${f.getDate()} ${f.getHours()}.${f.getMinutes()}`;
      link.setAttribute('download',`${nameDownload}.csv`);
      document.body.appendChild(link);
      link.click();
      blockUI.current.open(false);
    } catch (e) {
      setRequestFailed(true);
      setHasError({ message: e.response.data.message });
    }
  }

  const [csvPaytraceDownload, setCsvPaytraceDownload] = useState({ data: '' });
  const [openCsvDownload, setOpenCsvDownload] = useState(false);
  const csvLinkDownload = useRef();

  const handleDownloadFileRecords = async (id, name) => {
    try {
      blockUI.current.open(true);
      setRequestFailed(false);
      paymentService.init(accessToken);
      const { data } = await paymentService.listPaymentRecords(id);
      const newData = data.map(e => {
        const f = getDateWithDetectedBrowser(e.createdAt);
        let status = (e.status === 1) ? 'Success' : 'Error';
        return {
          'Transaction ID': e.transactionId,
          'Customer ID': e.customerId,
          'Amount': `${e.total} USD`,
          'Status Message': e.statusMessage,
          'Creation Date': `${f.getFullYear()}/${f.getMonth()}/${f.getDate()} ${f.getHours()}:${f.getMinutes()}`,
          'Status': status
        }
      });

      setCsvPaytraceDownload({ data: newData});
      setOpenCsvDownload(true);
      const link = document.createElement('a');
      link.href = csvLinkDownload.current.state.href;
      const f = getDateWithDetectedBrowser(name);
      let nameDownload = `${f.getFullYear()}:${f.getMonth()}:${f.getDate()} ${f.getHours()}.${f.getMinutes()}`;
      link.setAttribute('download', `${nameDownload} paytrace.csv`);
      document.body.appendChild(link);
      link.click();
      blockUI.current.open(false);
      setOpenCsvDownload(false);

    } catch (e) {
      setRequestFailed(true);
      setHasError({ message: e.response.data.message });
    }
  }

  const [openBtnDownloadWeek, setOpenBtnDownloadWeek] = useState(false);

  const handleDownloadReportWeek = async () => {
    try {
      blockUI.current.open(true);
      setRequestFailed(false);
      paymentService.init(accessToken);
      let date = new Date();
      date.setDate(date.getDate() - 14);
      const r1 = await paymentService.list(date);
      const newData = r1.data.data.map(e => {
        let status = (e.processingStatus === 1) ? 'Completed' : 'Incompleted';
        return {
          'Filename': e.name,
          'Upload Date': e.creationDate,
          'Status': status
        }
      });
      setCsvPaytraceDownload({ data: newData });
      setOpenCsvDownload(true);
      const link = document.createElement('a');
      link.href = csvLinkDownload.current.state.href;
      const f = new Date();
      let nameDownload = `${f.getFullYear()}:${f.getMonth()}:${f.getDate()} ${f.getHours()}.${f.getMinutes()}`;
      link.setAttribute('download', `${nameDownload} general report.csv`);
      document.body.appendChild(link);
      link.click();
      blockUI.current.open(false);
      setOpenCsvDownload(false);

    } catch (e) {
      setRequestFailed(true);
      setHasError({ message: e.response.data.message });
    }
  }

  const handleOpenModalDelete = (id) => {
    setpaymentDelete({
      idDelete: id
    })
    setopenModalDelete(true);
  }

  const handleCloseModalDelete = (e) => {
    setopenModalDelete(false);
  }

  function getModalStyle() {
    return {
      top: `50%`,
      left: `50%`,
      transform: `translate(-50%, -50%)`,
    };
  }

  const getDateWithDetectedBrowser = (date) => {
    const browser = detect();
    let f;
    (browser.name === 'safari')
      ? f = new Date(date.replace(/\s/, 'T'))
      : f = new Date(date);
    return f;
  }

  const handleDeletePayment = async (e) => {
    try {
      blockUI.current.open(true);
      setRequestFailed(false);
      paymentService.init(accessToken);
      paymentService.setHeaderContentType('application/x-www-form-urlencoded; charset=UTF-8');
      let formData = new URLSearchParams();
      formData.append('id', paymentDelete.idDelete);
      await paymentService.delete(formData);
      const positionDeleteRow = rows.findIndex(e => e.id == paymentDelete.idDelete);
      rows.splice(positionDeleteRow, 1);
      setRows([...rows]);
      blockUI.current.open(false);
    } catch (e) {
      setRequestFailed(true);
      setHasError({ message: e.response.data.message });
    }
  }

  const bodyDelete = (
    <div style={modalStyle} className={wizardStyle.paperModal}>
      <Grid container spacing={1}>
        <Grid item xs={11}>
          <h2 id="simple-modal-title">DELETE PAYMENT</h2>
        </Grid>
        <Grid item xs={1}>
          <IconButton aria-label="close" onClick={(e) => {
            setopenModalDelete(false)
          }}>
            <CloseIcon />
          </IconButton>
        </Grid>
        <Grid item xs={12}>
          <p id="simple-modal-description">
            Are you sure?
          </p>
          <div>
            <Box pb={4} />
          </div>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={(e) => { handleCloseModalDelete(e); handleDeletePayment(e); }}
            className={loginStyles.btnSubmit}
          >
            DELETE
          </Button>
        </Grid>
      </Grid>
    </div>
  );

  const [valueSelect, setValueSelect] = useState('');
  const [openSelect, setOpenSelect] = useState(false);

  let handleChangeSelectDate = async (e) => {

    try {
      blockUI.current.open(true);
      setValueSelect(e.target.value);
      setRequestFailed(false);
      setOpenBtnDownloadWeek(false);
      paymentService.init(accessToken);
      let r1 = {};
      if (e.target.value === 'lastTwoWeeks'){
        let f = new Date();
        f.setDate(f.getDate() - 14);
        r1 = await paymentService.list(f);
        setOpenBtnDownloadWeek(true);
      }else{
        r1 = await paymentService.list();
      }
      setRows(r1.data.data);
      blockUI.current.open(false);
    } catch (e) {
      setRequestFailed(true);
      setHasError({ message: e.response.data.message });
    }
  }

  return (
    <Container component="main" maxWidth="lg">
      {location.state && (
        <Collapse in={open}>
          <Alert severity="success" color="info" style={{ align: 'center' }} onClose={() => { setOpen(false); }}>
            {location.state.message}
          </Alert>
        </Collapse>
      )}
      <Typography variant="h4">Payments</Typography>
      <br/>
      <Typography variant="h6">Payment list</Typography>
      <br/>
      <div>
        <Grid container justify="space-between">
          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.button}
            startIcon={<AddIcon />}
            onClick={() => { history.push('create-payment') }}
          >
            Upload file
          </Button>

          <div>
            {
              (openBtnDownloadWeek)
                &&
                  <Tooltip title="Download general report" arrow>
                    <Button
                      style={{ marginTop: "32px" }}
                      variant="contained"
                      size="small"
                      onClick={handleDownloadReportWeek}
                      startIcon={<GetAppIcon style={{ marginLeft: "9px" }} />}
                    >
                    </Button>
                  </Tooltip>
            }

            <FormControl className={classes.formControl}>
              <InputLabel id="demo-simple-select-label">Please select date</InputLabel>
              <Select
                open={openSelect}
                labelId="demo-controlled-open-select-label"
                id="demo-controlled-open-select"
                onClose={() => { setOpenSelect(false)}}
                onOpen={() => { setOpenSelect(true) }}
                value={valueSelect}
                onChange={handleChangeSelectDate}
              >
                <MenuItem value='lastTwoWeeks'>Last two weeks</MenuItem>
                <MenuItem value='all' selected={true}>All</MenuItem>
              </Select>
            </FormControl>
          </div>
        </Grid>
      </div>

      <div style={{ height: 580, width: '100%', backgroundColor: 'white' }}>
        <DataGrid className={listStyle.dataGrid} rows={rows} columns={columns}
          pageSize={10}
        />
        <div>
          <Modal
            open={openModalDelete}
            onClose={(e) => {
              setopenModalDelete(false)
            }}
          >
            {bodyDelete}
          </Modal>
        </div>
      </div>

      {
       (openCsvDownload)
         &&
           <CSVLink
             data={csvPaytraceDownload.data}
             target="_blank"
             ref={csvLinkDownload}
           >
           </CSVLink>
      }

    </Container>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps)(ListPayments);

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    textTransform: 'none',
    backgroundColor: 'black',
    color: 'white',
    "&:hover": {
      backgroundColor: "black !important",
    }
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
    fontSize: 10
  },
}));
